import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

import Modal from './Modal.js';


class Propiedades extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                     {
                         create: true,
                         component: (props) => <Modal {...props} action="CREATE" />,
                         permission: 'ecommerce_articulos_caracteristicas_new',
                     },
                     {
                         edit: true,
                         component: (props) => <Modal {...props} action="EDIT" />,
                         permission: 'ecommerce_articulos_caracteristicas_edit',
                     },
                     {
                         detail: true,
                         component: (props) => <Modal {...props} action="DETAIL" />,
                         permission: 'ecommerce_articulos_caracteristicas_detail',
                     },
                     {
                         delete: true,
                         component: (props) => <Modal {...props} action="DELETE" />,
                         permission: 'ecommerce_articulos_caracteristicas_delete',
                     }
                ]}
                apiUrl={api.gestion.articulos.propiedades}
                columns={this.state.columns}
                title={"Caracteristicas"}
            />
        );
    }
}

export default Propiedades;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Propiedades/Propiedades.js